import React from 'react';
import {CobuText, CobuInput, CobuStack} from '@cobu/ui';
import { Strings } from '../../constants/Strings';

interface AboutSectionProps {
  about: string;
  onAboutChange: (text: string) => void;
}

export default function AboutSection({ about, onAboutChange }: AboutSectionProps) {
  const strings = Strings.get();

  return (
    <CobuStack 
      gap="$3" 
      bg="$background" 
      p="$4" 
      mb="$2"
      br="$2"
      w="100%"
    >
      <CobuText 
        variant="heading" 
        color="$cobuDarkBlue" 
        fontSize={21}
        fontWeight="bold"
      >
        {strings.profile.components.managePublicProfile.aboutSection.title}
      </CobuText>
      <CobuText 
        variant="body" 
        color="$cobuDarkBlue50" 
        fontSize={14}
        fontWeight="regular"
        mt="$3"
      >
        {strings.profile.components.managePublicProfile.aboutSection.description}
      </CobuText>
      <CobuStack w="100%" mt="$3">
        <CobuInput
          placeholder={strings.profile.components.managePublicProfile.aboutSection.placeholder}
          placeholderTextColor="$borderColorLight"
          multiline
          value={about}
          maxLength={200}
          onChangeText={onAboutChange}
          numberOfLines={4}
          br="$0"
          bc="transparent"
          fontSize="$3"
        />
      </CobuStack>
    </CobuStack>
  );
} 